'use strict'

export class AboutController {
  static usersCounter(): void {
    const initialValue = (): number => {
      const startTimestamp = new Date('2024-01-01T00:00:00Z').getTime()
      const currentTimestamp = new Date().getTime()
      const secondsPassed = Math.floor(
        (currentTimestamp - startTimestamp) / 1000
      )
      const secondsInYear =
        new Date().getFullYear() % 2 === 0 ? 31622400 : 31536000
      const usagePerMonth = 60000 * 60
      const growthFactor = 1.8

      return Math.round(
        usagePerMonth * Math.pow(growthFactor, secondsPassed / secondsInYear)
      )
    }
    const formatNumber = (num: number): string => {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }

    const selector: HTMLElement | null = document.querySelector('.users-stat')
    selector && (selector.innerHTML = '>' + formatNumber(initialValue()))
  }
}
